import { Component,OnInit} from '@angular/core';
import { EventSettingsModel,View,GroupModel} from '@syncfusion/ej2-schedule';
import { ScheduleServiceService } from '../../services/Schedule.service';
import { SchedulerEventModel } from '../../models/SchedulerEventModel';
import { PatientInfo } from '../../models/PatientInfo.model';
import { PaScheduledInfoModal } from '../../../PatientPanel/models/PaScheduledInfo.model';
import { ErrorModel } from '../../../../shared/models/Error.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';

@Component({
  selector: 'app-ha-scheduled-patient',
  templateUrl: './ha-scheduled-patient.component.html',
  styleUrls: ['./ha-scheduled-patient.component.css']
})

export class HaScheduledPatientComponent implements OnInit {
  doctors;
  IsAll: boolean = true;
  docEvents: SchedulerEventModel[];
  openModal: boolean = false;
  selectedPatient: PatientInfo;
  showOverlaySchedule: boolean;
  public ResourceDataSource: object[] = [];
  public groupData: GroupModel = {
  resources: ['Resources'],
  enableCompactView: false
  };

  public DataClassOne: object[] = [{
    id: 1,
    subject: 'abc',
    startTime: new Date(),
    endTime: new Date(),
  }];
  public DataClassTwo: object[] = [{
    id: 1,
    subject: '',
    startTime: new Date(),
    endTime: new Date(),
  }];

  public NewViewMode: View = 'Day';
  public NewViewModeTwo: View = 'Month';
  mainViewError = new ErrorModel();
  constructor(private _service: ScheduleServiceService) {}

  ngOnInit() {
    this.openModal = false;
    this.getDoctorsAndEvents();
    this.NewViewMode = 'Week';
  }


  getDoctorsAndEvents() {
    this.showOverlaySchedule = true;
    this._service.getDoctorsAndEvents().subscribe(
    (data: any) => {
      this.doctors = data['doctorNames'];
      this.ResourceDataSource = data['doctorNames'];
      this.docEvents = data['events'];
      this.DataClassOne.pop();
      for (let i = 0; i < data['events'].length; i++) {
        this.docEvents[i].fromTime = new Date(this.docEvents[i].start);
        this.docEvents[i].toTime = new Date(this.docEvents[i].end);
        this.DataClassOne.push(this.docEvents[i]);
      }
      this.NewViewMode = 'Week';
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlaySchedule = false;
    });
  }


  onPopUpOpen(event) {
    if (event.type == 'Editor') {
      event.cancel = true;
      let PatientId: string = event.data.patientId as string;
      let scheduleId: string = event.data.eventId as string;

      if (PatientId != undefined && PatientId != '') {
        this.selectedPatient = new PatientInfo();
        this.openModal = true;
        this._service.getPatientInfo(PatientId, scheduleId).subscribe(
        (data) => {

          this.selectedPatient = data as PatientInfo;
          this.selectedPatient.dob = new Date(this.selectedPatient.dobDate).toLocaleDateString('yyyy-MM-dd');
        },
        (error) => {
          AlertMessages.Show('Failed','Could not get info!', AlertType.Error);
          this.openModal = false;
        });
      }
    }
  }

  changeDoctor(docId) {
    if (docId == '') {
      this.IsAll = !this.IsAll;
      this.DataClassOne = this.docEvents;
    } else {
      this.IsAll = false;
      var data2length = this.DataClassTwo.length;
      for (let i = 0; i < data2length; i++) {
        this.DataClassTwo.pop();
      }
      let evt = this.docEvents.filter(i => i.docId == docId);
      for (let i = 0; i < evt.length; i++) {
        this.DataClassTwo.push(evt[i]);
      }
      this.showOverlaySchedule = true;
      this.IsAll = true;
      setTimeout(() => {
        this.IsAll = false;
        this.showOverlaySchedule = false;
      }, 2000);
    }
  }

  generateData(): object[] {
    return this.DataClassOne;
  }

  generateDataTwo(): object[] {
    return this.DataClassTwo;
  }

  closeModal() {
    this.openModal = false;
  }

  public EventSettingsOne: EventSettingsModel = {
    dataSource: this.generateData(),
    fields: {
      subject: {
        name: 'subject'
      },
      startTime: {
        name: 'fromTime'
      },
      endTime: {
        name: 'toTime'
      },
    }
  };

  public EventSettingsTwo: EventSettingsModel = {
    dataSource: this.generateDataTwo(),
    fields: {
      subject: {
        name: 'subject'
      },
      startTime: {
        name: 'fromTime'
      },
      endTime: {
        name: 'toTime'
      },
    }
  };

}
